<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Dienst bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditPackageDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-2 pa-2" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-text-field
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        label="Titel"
        v-model="selectedPackage.title"
        :rules="requiredRules"
        required
      ></v-text-field>

      <v-text-field
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        label="Naam dienst"
        v-model="selectedPackage.name"
        :rules="requiredRules"
        required
        hint="Machinename invullen. Zodat er gefilterd kan worden of de klant deze dienst al heeft."
        persistent-hint
      ></v-text-field>

      <v-select
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        :item-color="companyPrimaryColor"
        style="margin: 15px 0;"
        v-model="selectedPackage.showTo"
        :items="showTo"
        label="Selecteer wie  dit pakket kan zien"
        item-text="name"
        item-value="id"
        prepend-inner-icon="visibility"
      ></v-select>

      <div
        v-if="selectedPackage.type != 'update'"
        class="upload-news-image-wrapper clear"
      >
        <div class="upload-image">
          <p>Upload afbeelding</p>
          <div v-if="selectedPackage.imageUrl" class="logo-upload-preview">
            <v-img
              :src="selectedPackage.imageUrl"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
            <div v-if="uploading == true" class="upload-bar">
              <p>{{ uploadProgress }} %</p>
              <div
                class="upload-bar-inner"
                v-bind:style="{ backgroundColor: companyPrimaryColor }"
              ></div>
            </div>
          </div>
          <v-btn
            class="ma-0"
            raised
            :color="companyPrimaryColor"
            dark
            @click="onFileSelect"
            >Kies afbeelding</v-btn
          >
          <input
            type="file"
            style="display: none;"
            ref="fileInput"
            accept="image/*"
            @change="onFilePicked"
          />
        </div>
      </div>

      <v-select
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        :item-color="companyPrimaryColor"
        v-model="selectedDescriptionRole"
        :items="roles"
        label="Selecteer rol voor intro en omschrijving"
        item-text="name"
        item-value="id"
        prepend-inner-icon="group"
        hint="Voeg een omschrijving toe per doelgroep voor optimale conversie."
        persistent-hint
      ></v-select>

      <div class="field-wrapper" style="max-width: 100%; overflow: hidden;">
        <label class="custom-label">Intro voor {{ selectedRole }}</label>
        <ckeditor
          type="classic"
          v-if="selectedDescriptionRole == 'admin'"
          v-model="selectedPackage.intro.admin"
          :config="editorConfig"
          :upload-adapter="UploadAdapter"
        ></ckeditor>
        <ckeditor
          type="classic"
          v-if="selectedDescriptionRole == 'manager'"
          v-model="selectedPackage.intro.admin"
          :config="editorConfig"
          :upload-adapter="UploadAdapter"
        ></ckeditor>
        <ckeditor
          type="classic"
          v-if="selectedDescriptionRole == 'employee'"
          v-model="selectedPackage.intro.admin"
          :config="editorConfig"
          :upload-adapter="UploadAdapter"
        ></ckeditor>
      </div>

      <div class="field-wrapper" style="max-width: 100%; overflow: hidden;">
        <v-tooltip right>
          <template slot="activator">
            <label class="custom-label"
              >Omschrijving voor {{ selectedRole
              }}<v-icon small right :color="companyPrimaryColor"
                >help</v-icon
              ></label
            >
          </template>
          <span style="color: #fff;"
            >Omschrijving van de dienst voor {{ selectedRole }}.</span
          >
        </v-tooltip>
        <ckeditor
          type="classic"
          v-if="selectedDescriptionRole == 'admin'"
          v-model="selectedPackage.description.admin"
          :config="editorConfig"
          :upload-adapter="UploadAdapter"
        ></ckeditor>
        <ckeditor
          type="classic"
          v-if="selectedDescriptionRole == 'manager'"
          v-model="selectedPackage.description.managers"
          :config="editorConfig"
          :upload-adapter="UploadAdapter"
        ></ckeditor>
        <ckeditor
          type="classic"
          v-if="selectedDescriptionRole == 'employee'"
          v-model="selectedPackage.description.employees"
          :config="editorConfig"
          :upload-adapter="UploadAdapter"
        ></ckeditor>
      </div>

      <v-text-field
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        style="margin: 15px 0;"
        label="CTA -knop tekst"
        v-model="selectedPackage.cta"
        :rules="requiredRules"
        counter="20"
        required
      >
      </v-text-field>

      <v-select
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        :item-color="companyPrimaryColor"
        style="margin: 15px 0;"
        v-model="selectedPackage.ctaAction"
        :items="actions"
        label="CTA bestemming"
        item-text="name"
        item-value="id"
        prepend-inner-icon="link"
        hint="Wat gebeurd er bij het klikken op de CTA-knop"
        persistent-hint
      ></v-select>

      <div
        v-if="selectedPackage.ctaAction == 'customMessage'"
        class="field-wrapper"
        style="max-width: 100%; overflow: hidden; margin: 15px 0;"
      >
        <v-tooltip right>
          <template slot="activator">
            <label class="custom-label"
              >Aangepast bericht<v-icon small right :color="companyPrimaryColor"
                >help</v-icon
              ></label
            >
          </template>
          <span style="color: #fff;"
            >Bericht wordt getoond als op de CTA-knop is geklikt</span
          >
        </v-tooltip>
        <ckeditor
          type="classic"
          v-model="selectedPackage.ctaActionDescription"
          :config="editorConfig"
          :upload-adapter="UploadAdapter"
        ></ckeditor>
      </div>

      <v-switch
        style="margin: 15px 0;"
        :color="companyPrimaryColor"
        v-model="selectedPackage.action"
        class="pa-0"
        hide-details
      >
        <template slot="label">
          <span style="color: #333; margin-right: 5px;">Actie</span>
          <v-tooltip class="ma-0 pa-0" right>
            <v-icon small :color="companyPrimaryColor" slot="activator"
              >help</v-icon
            >
            <span style="color: #fff;"
              >Aanvinken wanneer er een speciale actie is.</span
            >
          </v-tooltip>
        </template>
      </v-switch>

      <v-text-field
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        style="margin: 0 0 15px 0;"
        label="Prijs"
        v-model="selectedPackage.price"
        :rules="requiredRules"
        required
      >
      </v-text-field>

      <v-text-field
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        :item-color="companyPrimaryColor"
        v-if="selectedPackage.action"
        style="margin: 0 0 15px 0;"
        label="Beschrijving actie"
        v-model="selectedPackage.actionDescription"
        :rules="requiredRules"
        counter="15"
        hint="Wordt weergegeven boven CTA knop in tegel"
        persistent-hint
        required
      >
      </v-text-field>

      <v-switch
        :color="companyPrimaryColor"
        v-model="selectedPackage.published"
        class="pa-0"
        hide-details
      >
        <template slot="label">
          <span style="color: #333; margin-right: 5px;">Publiceren</span>
          <v-tooltip class="ma-0 pa-0" right>
            <v-icon small :color="companyPrimaryColor" slot="activator"
              >help</v-icon
            >
            <span style="color: #fff;"
              >Bericht wordt alleen getoond aan gebruikers als deze gepubliceerd
              is.</span
            >
          </v-tooltip>
        </template>
      </v-switch>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditPackageDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed"
              :depressed="!changed"
              :dark="changed"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="updatePackage()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import { Chrome } from "vue-color";
import platform from "platform";

export default {
  name: "edit-package-form",
  props: {
    selectedPackage: Object,
    selectedPackageOriginal: Object,
  },
  data() {
    return {
      editorConfig: {
        toolbar: [
          "heading",
          "bold",
          "italic",
          "bulletedList",
          "numberedList",
          "|",
          "link",
          "ImageUpload",
          "|",
          "insertTable",
          "|",
          "undo",
          "redo",
        ],
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
      },
      publishDateDialog: false,
      valid: false,
      selectedDescriptionRole: "admin",
      requiredRules: [(v) => !!v || "Dit veld is verplicht"],
      valid: true,
      filename: null,
      image: null,
      showTo: [
        {
          name: "Iedereen",
          id: "all",
        },
        {
          name: "Kappers",
          id: "kapper",
        },
        {
          name: "Anders",
          id: "other",
        },
      ],
      actions: [
        {
          name: "Bel ons",
          id: "callUs",
        },
        {
          name: "Aangepast bericht",
          id: "customMessage",
        },
      ],
      roles: [
        {
          name: "Admins",
          id: "admin",
        },
        {
          name: "Managers",
          id: "manager",
        },
        {
          name: "Medewerkers",
          id: "employee",
        },
      ],
      feedback: null,
      uploading: false,
      uploadProgress: null,
      file: {},
    };
  },

  methods: {
    closeEditPackageDialog() {
      // Dialog sluiten en waardes resetten
      this.$emit("editPackageDialogChange", false);
      this.feedback = null;
    },

    onFileSelect() {
      // Openen van selectievenster in browser
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      // Afbeelding selecteren
      const files = event.target.files;
      this.file = files[0];
      let filename = files[0].name;
      this.filename = filename;
      console.log("files: " + filename);
      if (filename.lastIndexOf(".") <= 0) {
        this.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedPackage.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
      this.feedback = null;
    },

    UploadAdapter(loader) {
      let token = Math.random()
        .toString(36)
        .substr(2);
      this.loader = loader;

      let company = "hogans";
      let imageUrl = "";
      loader.file.then((response) => {
        this.upload = () => {
          return new Promise((resolve, reject) => {
            const file = response;
            const filename = response.name;

            const ext = filename.slice(filename.lastIndexOf("."));
            const fileUrl = "wysiwyg/" + filename + "-" + token + ext;

            let uploadTask = firebase
              .storage()
              .ref(fileUrl)
              .put(file);

            uploadTask.on(
              "state_changed",
              (taskSnapshot) => {},
              (error) => {
                console.error(error);
                reject();
              },
              () => {
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then((url) => {
                    imageUrl = url;
                    resolve();
                  })
                  .catch((error) => {
                    reject();
                  });
              },
            );
          }).then(() => {
            return {
              default: imageUrl,
            };
          });
        };
      });
    },

    updatePackage() {
      // Package toevoegen
      this.feedback = null;

      if (
        this.selectedPackage.imageUrl &&
        this.selectedPackage.description.admin &&
        this.selectedPackage.intro.admin &&
        this.selectedPackage.title &&
        this.selectedPackage.name &&
        this.selectedPackage.cta
      ) {
        db.collection("packages")
          .doc(this.selectedPackage.id)
          .update({
            title: this.selectedPackage.title,
            name: this.selectedPackage.name,
            intro: this.selectedPackage.intro,
            description: this.selectedPackage.description,
            cta: this.selectedPackage.cta,
            ctaAction: this.selectedPackage.ctaAction,
            ctaActionDescription: this.selectedPackage.ctaActionDescription,
            price: this.selectedPackage.price,
            showTo: this.selectedPackage.showTo,
            action: this.selectedPackage.action,
            actionDescription: this.selectedPackage.actionDescription,
            published: this.selectedPackage.published,
            publishDate: new Date(),
            user: this.userFirstName + " " + this.userLastName,
          })
          .then(async (docRef) => {
            if (this.filename) {
              await this.uploadPackageImage(this.selectedPackage.id);
            }
          })
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action:
                "Pillarrr Dienst gewijzigd: " +
                this.selectedPackageOriginal.name,
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              extra:
                "<b>ORIGINELE GEGEVENS</b><br>" +
                "<b>Titel</b>: " +
                this.selectedPackageOriginal.title +
                "<br>" +
                "<b>Omschrijving</b>: " +
                this.selectedPackageOriginal.intro.admin +
                "<br> " +
                this.selectedPackageOriginal.description.admin +
                "<br>" +
                "<b>CTA</b>: " +
                this.selectedPackageOriginal.cta +
                "<br>" +
                "<b>Gepubliceerd</b>: " +
                this.selectedPackageOriginal.published +
                "<br><br> " +
                "<b>AANGEPASTE GEGEVENS</b><br>" +
                "<b>Titel</b>: " +
                this.selectedPackage.title +
                "<br>" +
                "<b>Omschrijving</b>: " +
                this.selectedPackage.intro.admin +
                "<br> " +
                this.selectedPackage.description.admin +
                "<br>" +
                "<b>CTA</b>: " +
                this.selectedPackage.cta +
                "<br>" +
                "<b>Gepubliceerd</b>: " +
                this.selectedPackage.published,
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeEditPackageDialog();
            console.log("Package succesfully updated");
          });
      } else {
        this.feedback = "Vul alle velden in om een dienst toe te voegen.";
      }
    },

    uploadPackageImage(docId) {
      // Afbeelding uploaden en News doc updaten
      return new Promise((resolve, reject) => {
        console.log("start storen");
        const file = this.file;
        const filename = this.filename;
        const ext = filename.slice(filename.lastIndexOf("."));
        const fileUrl = "packages/" + docId + ext;
        this.uploading = true;
        let uploadTask = firebase
          .storage()
          .ref(fileUrl)
          .put(file);

        uploadTask.on(
          "state_changed",
          (taskSnapshot) => {
            var progress = Math.ceil(
              (taskSnapshot.bytesTransferred / taskSnapshot.totalBytes) * 100,
            );
            this.uploadProgress = progress;
          },
          (error) => {
            console.log(error);
            reject();
          },
          () => {
            console.log("The upload is compleet");
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then((url) => {
                db.collection("packages")
                  .doc(docId)
                  .update({
                    imageUrl: url,
                  })
                  .then(() => {
                    resolve();
                    this.uploading = false;
                    this.uploadProgress = null;
                  })
                  .catch((error) => {
                    reject();
                    this.uploading = false;
                    this.uploadProgress = null;
                  });
              })
              .catch((error) => {
                reject();
                this.uploading = false;
                this.uploadProgress = null;
              });
          },
        );
      });
    },
  },

  computed: {
    selectedRole() {
      // Naam van de geselecteerde contenttype
      let roleType;
      this.roles.map((role) => {
        if (role.id == this.selectedDescriptionRole) {
          roleType = role.name.toLowerCase();
        }
      });
      return roleType;
    },

    changed() {
      // Kijken of content veranderd is
      if (
        _.isEqual(this.selectedPackage, this.selectedPackageOriginal) == false
      ) {
        return true;
      } else {
        return false;
      }
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
  },
};
</script>
